import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BasePublicSearchDto } from '../../../shared/modules/base/dtos/base-public-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { VehicleFeatureItemDto } from '../../../shared/modules/vehicle-feature-items/dtos/vehicle-feature-item.dto';
import { VehicleBodyTypeEnum } from '../enums/vehicle-body-type.enum';
import { VehicleDriveTrainTypeEnum } from '../enums/vehicle-drive-train-type.enum';
import { VehicleFuelTypeEnum } from '../enums/vehicle-fuel-type.enum';
import { VehiclePowerPlantTypeEnum } from '../enums/vehicle-power-plant-type.enum';
import { VehicleSteeringPositionEnum } from '../enums/vehicle-steering-position.enum';
import { VehicleTransmissionTypeEnum } from '../enums/vehicle-transmission-type.enum';
import { VehicleTypeEnum } from '../enums/vehicle-type.enum';

/**
 * Vehicle DTO for public searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehiclePublicSearchDto extends BasePublicSearchDto {
  uuid!: string;
  makeFull?: string | null;
  seriesTrimFull?: string | null;
  type!: VehicleTypeEnum;
  fuelType?: VehicleFuelTypeEnum | null;
  bodyType!: VehicleBodyTypeEnum;
  transmissionType?: VehicleTransmissionTypeEnum | null;
  exteriorColorName?: string | null;
  interiorColorName?: string | null;
  steeringPosition?: VehicleSteeringPositionEnum | null;
  doors?: number | null;
  seats?: number | null;
  driveTrainType?: VehicleDriveTrainTypeEnum | null;
  primaryPowerPlantType?: VehiclePowerPlantTypeEnum | null;
  secondaryPowerPlantType?: VehiclePowerPlantTypeEnum | null;
  featureItems?: VehicleFeatureItemDto[] | null;
  files?: FileDto[] | null;
  vehicleCategoryName?: string | null;
  depositPercentage?: number | null;
  depositFlatRate?: number | null;
  excessAmount?: number | null;
  reducedExcessAmount?: number | null;
}
